<template>
  <b-button variant="primary">
    <a href="https://t.me/joinchat/IPlgxiJA1wwxMDVl" target="_blank" style="color: #FFFFFF;">
      <i class="lab la-telegram"></i>
      Hỗ trợ
      <b-badge variant="light" class="ml-2">24/7</b-badge>
    </a>
  </b-button>
</template>
<script>
export default {
  name: 'ContactButton'
}
</script>
<style scoped>
</style>
